export default __webpack_public_path__ + "static/media/n2.c80bb3b7.png";